import React from 'react';
import { Box, Button, Chip, CircularProgress, Stack, Typography } from '@mui/material';
import { hasPlanningCycle, IBiePlanningContext } from './bieprofile.models';

export interface PlanningContextBannerProps {
  context?: IBiePlanningContext | null;
  loading?: boolean;
  switching?: boolean;
  onChangePlanningCycle?: () => void;
}

export default class PlanningContextBanner extends React.Component<PlanningContextBannerProps> {
  public render(): React.ReactNode {
    const { context, loading = false, switching = false, onChangePlanningCycle } = this.props;

    if (loading) {
      return <Stack direction="row" spacing={1.5} alignItems="center" sx={{ py: 1.5 }}>
        <CircularProgress size={20} />
        <Typography variant="body2">Loading Planning Context…</Typography>
      </Stack>;
    }

    const selected = hasPlanningCycle(context);

    return <Box sx={{ px: 2, py: 1.5, border: 1, borderColor: 'divider', borderRadius: 1 }}>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}
        alignItems={{ xs: 'flex-start', md: 'center' }} justifyContent="space-between">
        <Box>
          <Typography variant="overline">Planning Context</Typography>
          <Typography variant="h6">
            {selected ? context?.pcn || context?.pcc : 'No Planning Cycle selected'}
          </Typography>
          {selected && <Stack direction="row" spacing={1} sx={{ mt: 0.75, flexWrap: 'wrap', rowGap: 1 }}>
            {context?.bpn && <Chip size="small" label={context.bpn} variant="outlined" />}
            {context?.hdn && <Chip size="small" label={`Dataset: ${context.hdn}`} variant="outlined" />}
            {context?.scn && <Chip size="small" label={`Scenario: ${context.scn}`} variant="outlined" />}
          </Stack>}
        </Box>
        {onChangePlanningCycle && <Button
          variant={selected ? 'outlined' : 'contained'} disabled={switching}
          onClick={onChangePlanningCycle}>
          {switching ? 'Switching…' : selected ? 'Change Planning Cycle' : 'Open Planning Cycle'}
        </Button>}
      </Stack>
    </Box>;
  }
}
